import React, { useEffect, useState } from "react";
import "./App.css";
import {
  // BrowserRouter,
  Route,
  Routes,
  Navigate,
  Outlet,
  useNavigate,
} from "react-router-dom";
import JobOrders from "./Screens/jobOrders";
import FindTalent from "./Screens/findTalent";
import Forgetpassword from "./Screens/forgetpassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Createpassword from "./Screens/createpassword";
import Changepassword from "./Screens/changepassword";
import JobDetails from "./Screens/jobDetails";
import SearchCandidate from "./Screens/searchCandidate";
import Login from "./Screens/login";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import Createjob from "./Screens/Createjob";
// import useAxiosInterceptor from "./interceptors/axios";
import axios from "axios";
import Draggable from "react-draggable";
import { Box, IconButton, Divider, Typography, Skeleton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import CancelPresentationOutlinedIcon from "@mui/icons-material/CancelPresentationOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigation = useNavigate();
  const token = localStorage.getItem("token");

  const [uploadPanelOpen, setUploadPanelOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [processedFiles, setProcessedFiles] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const mailtoken = window.location.pathname?.split("/")[2]?.split("=")[1];

  const baseURL = process.env.REACT_APP_BASEURL;

  // useAxiosInterceptor();

  useEffect(() => {
    // Check if token exists and set isLoggedIn accordingly
    if (token) {
      setIsLoggedIn(true);
    }
  }, [token]);

  useEffect(() => {
    const jobId = localStorage.getItem("bulkUploadJobId");
    if (jobId) {
      pollStatus(jobId);
      setUploadPanelOpen(true);
    }
  }, []);

  const handleOpenDetails = () => {
    // navigation("/added-candidates", { state: { processedFiles } });
    localStorage.setItem("jobOrdersTab", "1");
    navigation("/jobOrders");
  };

  const pollStatus = (jobId) => {
    localStorage.setItem("bulkUploadJobId", jobId);
    setIsProcessing(true);
    const intervalId = setInterval(async () => {
      try {
        const { data } = await axios.get(`${baseURL}/status/${jobId}`, {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        });

        const { total, processed } = data.message;
        setUploadProgress(processed);
        setProcessedFiles(data.message.processedFiles);
        console.log(`Progress: ${processed}/${total}`);
        if (parseInt(total) === parseInt(processed)) {
          clearInterval(intervalId);
          setIsProcessing(false);
          console.log("Processing complete!");
        }
      } catch (err) {
        console.error("Error polling status:", err);
        clearInterval(intervalId);
        setIsProcessing(false);
      }
    }, 10000);
  };

  return (
    <div>
      {/* <BrowserRouter> */}
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/login"
          element={<Login setIsLoggedIn={setIsLoggedIn} />}
        />
        <Route
          path="/forgetpassword"
          element={<Forgetpassword setIsLoggedIn={setIsLoggedIn} />}
        />
        <Route
          path={`/createpassword/_secure_ARJ_=${mailtoken}`}
          element={<Createpassword />}
        />
        <Route element={<PrivateRoutes />}>
          <Route path="/changepassword" element={<Changepassword />} />
          <Route
            path="/jobOrders"
            element={
              <JobOrders
                pollStatus={pollStatus}
                setUploadProgress={setUploadProgress}
                setUploadingFiles={setUploadingFiles}
                setUploadPanelOpen={setUploadPanelOpen}
                processedFiles={processedFiles}
                setProcessedFiles={setProcessedFiles}
                isProcessing={isProcessing}
                setIsProcessing={setIsProcessing}
              />
            }
          />
          <Route path="/Postjob" element={<Createjob />} />
          <Route path="/Find-talents" element={<FindTalent />} />
          <Route path="/jobOrders/:id" element={<JobDetails />} />
          <Route path="/searchCandidate" element={<SearchCandidate />} />
          <Route element={<Navigate to="/jobOrders" />} />
        </Route>
      </Routes>
      {/* </BrowserRouter> */}
      <ToastContainer autoClose={2000} position="top-right" theme="colored" />

      {uploadPanelOpen && (
        <Draggable handle=".upload-drag-handle" bounds="body">
          <Box
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
              width: 480,
              zIndex: 1300,
              bgcolor: "white",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <Box
              className="upload-drag-handle"
              sx={{
                cursor: "move",
                p: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography fontWeight="500">Adding Bulk Candidates</Typography>
              {uploadProgress >= uploadingFiles.length ? (
                <IconButton
                  onClick={() => {
                    setUploadPanelOpen(false);
                    localStorage.removeItem("bulkUploadJobId");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              ) : (
                <OpenInNewOutlinedIcon
                  sx={{
                    border: "1px solid #D9EAFB",
                    borderRadius: "8px",
                    padding: "6px",
                    fontSize: "20px",
                    color: "#1A1A1A",
                    cursor: "pointer",
                  }}
                  onClick={handleOpenDetails}
                />
              )}
            </Box>
            <Divider />

            {uploadProgress < uploadingFiles.length ? (
              <>
                <Box p={"20px 20px 0px 20px"}>
                  {processedFiles.slice(0, 2).map((file, index) => (
                    <Box key={index} mb={2}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={2}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={2}
                          flex={1}
                        >
                          {file.status === "successful" ? (
                            <TaskOutlinedIcon
                              sx={{
                                color: "#4CAF50",
                                border: "1px solid #3F95EA33",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "20px",
                              }}
                            />
                          ) : (
                            <CancelPresentationOutlinedIcon
                              sx={{
                                color: "#E25C72",
                                border: "1px solid #3F95EA33",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "20px",
                              }}
                            />
                          )}

                          <Box>
                            <Typography
                              variant="body1"
                              color="text.primary"
                              fontWeight="bold"
                              fontSize={18}
                              noWrap
                              sx={{ maxWidth: 220 }}
                            >
                              {file.fileName}
                            </Typography>
                            <Typography
                              color={
                                file.status === "successful"
                                  ? "text.secondary"
                                  : "error"
                              }
                              size={14}
                            >
                              {file.fileSize < 1024 * 1024
                                ? `${(file.fileSize / 1024).toFixed(2)} KB`
                                : `${(file.fileSize / (1024 * 1024)).toFixed(
                                    2
                                  )} MB`}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Divider />
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  p={2.5}
                >
                  <Skeleton variant="circular" width={40} height={40} />
                  <Box sx={{ flex: 1, ml: 2 }}>
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </Box>
                </Box>
                <Divider />
                <Box display="flex" flexDirection="column" p={"10px 20px"}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        flexGrow: 1,
                        height: 5,
                        backgroundColor: "#e0e0e0",
                        borderRadius: 5,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          width: `${
                            (uploadProgress / uploadingFiles.length) * 100
                          }%`,
                          backgroundColor: "#3f95ea",
                          height: "100%",
                        }}
                      />
                    </Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      minWidth={30}
                    >
                      {Math.round(
                        (uploadProgress / uploadingFiles.length) * 100
                      )}
                      %
                    </Typography>
                  </Box>
                  <Typography fontSize={14}>
                    {uploadProgress}/{uploadingFiles.length} Candidates
                    Processed
                  </Typography>
                </Box>
              </>
            ) : (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={2}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <CheckCircleOutlineOutlinedIcon
                    sx={{ color: "#4CAF50", fontSize: 40 }}
                  />
                  <Box>
                    <Typography sx={{ fontSize: "18px", fontWeight: "500" }}>
                      Candidates Processed Successfully!
                    </Typography>
                    {/* <Typography fontSize={14} color="text.secondary">
                      {uploadingFiles.length}/{uploadingFiles.length}
                    </Typography> */}
                  </Box>
                </Box>
                <IconButton>
                  <OpenInNewOutlinedIcon
                    sx={{
                      border: "1px solid #D9EAFB",
                      borderRadius: "8px",
                      padding: "6px",
                      fontSize: "20px",
                      color: "#1A1A1A",
                    }}
                    onClick={handleOpenDetails}
                  />
                </IconButton>
              </Box>
            )}
          </Box>
        </Draggable>
      )}
    </div>
  );
}

function PrivateRoutes({ children }) {
  const tokenFromLocalStorage =
    useSelector((state) => state.user.token) || Cookies.get("_secure_ARJ_");
  const refreshtoken =
    useSelector((state) => state.user.refreshToken) ||
    Cookies.get("_secure_ref");

  const isAuthenticated = refreshtoken || tokenFromLocalStorage;
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children ? children : <Outlet />;
}

export default App;
